<h2 mat-dialog-title>{{ 'releaseNotes.title' | translate }}</h2>
<mat-dialog-content class="release-notes-dialog__content">
  <app-release-notes-list></app-release-notes-list>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="close()">{{ 'releaseNotes.close' | translate }}</button>
</mat-dialog-actions>
